import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  word-break: break-word;

  & + & {
    margin-top: var(--space-500);
    padding-top: var(--space-500);

    border-top: 1px solid var(--bg-transparent-strong);
  }
`

export const Title = styled.div`
  margin-bottom: var(--space-200);

  letter-spacing: var(--font-letter-spacing-looser);
  font-size: var(--font-size-200);
  line-height: var(--font-line-height-200);
  color: var(--text-secondary);
`

export const Children = styled.div`
  line-height: 24px;
`
